import { render, staticRenderFns } from "./CreateOrderPane.vue?vue&type=template&id=04d7ee14&scoped=true"
import script from "./CreateOrderPane.vue?vue&type=script&lang=js"
export * from "./CreateOrderPane.vue?vue&type=script&lang=js"
import style0 from "./CreateOrderPane.vue?vue&type=style&index=0&id=04d7ee14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d7ee14",
  null
  
)

export default component.exports